import { gql } from '@apollo/client';

// OTRIX Play — prácticas guiadas de recuperación (día de descanso) + historial.

export const PLAY_RECOVERY_STEP_FIELDS = gql`
  fragment PlayRecoveryStepFields on PlayRecoveryStep {
    id
    position
    key
    title
    description
    type
    duration_seconds
    video_url
    image_url
    pattern
    # Marcas de recorte del video del paso, en MILISEGUNDOS (null = video entero). El recorte es
    # no destructivo: reajustarlo es cambiar un entero, no volver a subir el archivo.
    video_start_ms
    video_end_ms
    video_duration_ms
    video_has_audio
  }
`;

export const PLAY_RECOVERY_PRACTICE_FIELDS = gql`
  fragment PlayRecoveryPracticeFields on PlayRecoveryPractice {
    id
    key
    title
    description
    category
    icon
    minutes
    breathing_pattern
    video_url
    video_start_ms
    video_end_ms
    video_duration_ms
    video_has_audio
    # Video introductorio de la práctica: es columna de la práctica y NO un paso más, porque un
    # paso-intro contaminaría sumSteps, stepAt y el % de logro, y las prácticas de respiración
    # no tienen pasos y aun así pueden querer saludo.
    intro_video_url
    intro_start_ms
    intro_end_ms
    intro_duration_ms
    intro_ready_ms
    intro_has_audio
    intro_required
    is_active
    position
    music_track {
      id
      title
      category
      duration_seconds
      file_url
    }
    music_album {
      id
      title
      is_personal
      tracks {
        id
        title
        category
        duration_seconds
        file_url
      }
    }
    steps {
      ...PlayRecoveryStepFields
    }
  }
  ${PLAY_RECOVERY_STEP_FIELDS}
`;

export const PLAY_RECOVERY_PRACTICES = gql`
  query playRecoveryPractices {
    playRecoveryPractices {
      ...PlayRecoveryPracticeFields
    }
  }
  ${PLAY_RECOVERY_PRACTICE_FIELDS}
`;

export const ADMIN_PLAY_RECOVERY_PRACTICES = gql`
  query adminPlayRecoveryPractices {
    adminPlayRecoveryPractices {
      ...PlayRecoveryPracticeFields
    }
  }
  ${PLAY_RECOVERY_PRACTICE_FIELDS}
`;

export const MY_PLAY_RECOVERY_SESSIONS = gql`
  query myPlayRecoverySessions($first: Int) {
    myPlayRecoverySessions(first: $first) {
      id
      practice_id
      practice_key
      started_at
      completed_at
      total_seconds
      completed_steps
      total_steps
      completion_percent
      status
      created_at
    }
  }
`;

export const LOG_PLAY_RECOVERY_SESSION = gql`
  mutation logPlayRecoverySession($input: LogPlayRecoverySessionInput!) {
    logPlayRecoverySession(input: $input) {
      id
      practice_key
      total_seconds
      completion_percent
      status
    }
  }
`;

export const SAVE_PLAY_RECOVERY_PRACTICE = gql`
  mutation savePlayRecoveryPractice($input: PlayRecoveryPracticeInput!) {
    savePlayRecoveryPractice(input: $input) {
      ...PlayRecoveryPracticeFields
    }
  }
  ${PLAY_RECOVERY_PRACTICE_FIELDS}
`;

export const DELETE_PLAY_RECOVERY_PRACTICE = gql`
  mutation deletePlayRecoveryPractice($id: ID!) {
    deletePlayRecoveryPractice(id: $id)
  }
`;
